export const iconFontAwesomeMoneyMoneyBillWave = (
	<i className="fa-solid fa-money-bill-wave"></i>
);
